module.exports = __webpack_public_path__ + "img/Cooperativesupplier.fb842b60.png";